<template>
  <router-view />
</template>

<script lang="ts">
/**
 * This component should be use exclusively in the router.
 * It is used to structure the urls.
 */
import { defineComponent } from "vue";

export default defineComponent({});
</script>
